import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi, type PurchaseRequisition } from '../../api/procurement';

export function RequisitionPage() {
  const [items, setItems] = useState<PurchaseRequisition[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void procurementApi.listRequisitions().then(setItems);
  }, []);

  async function createPR() {
    await procurementApi.createRequisition({
      priority: 'high',
      items: [{ sku: 'SKU-001', quantity: 100, unit_price: 250 }],
    });
    setMsg('Requisition created');
    setItems(await procurementApi.listRequisitions());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Purchase requisitions</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createPR()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create requisition</button>
      <ul className="mt-6 space-y-2">
        {items.map((pr) => (
          <li key={pr.id} className="rounded border p-3 text-sm">
            {pr.pr_number} — {pr.status} · ₹{pr.total_amount}
          </li>
        ))}
      </ul>
    </div>
  );
}
